/**
 * return a formatted error message - if no message is passed a default is returned
 * @param {*} error - the error message in the form of a string or error.messages
 * @param {*} componentName - if applied it is appended to situations where no error message was supplied
 */
export const apiErrorMessageFormatter = (error, componentName) => {
    if (typeof error === 'string') {
        return error;
    } else if (error ?.messages) {
        return error.messages;
    }
    let defaultMessage = 'An error occurred, however no error message was specified';
    return componentName ? defaultMessage.concat(' Applies to component ').concat(componentName) : defaultMessage;
};




// WEBPACK FOOTER //
// ./services/errorService.js